/* eslint no-console: 0 */
import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.isLoggedIn()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      api_access_token: apiAccessToken,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    // Сессия из ?token=... в URL авторизуется одним заголовком api_access_token,
    // обычный логин — заголовками devise_token_auth.
    if (apiAccessToken) {
      Object.assign(wootApi.defaults.headers.common, {
        api_access_token: apiAccessToken,
      });
    } else {
      Object.assign(wootApi.defaults.headers.common, {
        'access-token': accessToken,
        'token-type': tokenType,
        client,
        expiry,
        uid,
      });
    }
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
